import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "utils/helpers/analytics"; // prilagodi putanju

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Poziva se svaki put kad se promeni ruta
    trackPageView(location.pathname);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
